import { selfixSmallLogoIcon } from '../../assets';
import './index.css';
import SocketStore from '../../stores/SocketStore';
import { observer } from 'mobx-react';
import Profile from '../Profile';
import ShapeTool from '../ShapeTool';


const TechCallLeftSide = () => {


  const tools = [
    {
      key: 'free-hand',
      action: () => {
        SocketStore.setSelectedShape('free-hand');
      },
    },
    {
      key: 'circle',
      action: () => {
        SocketStore.setSelectedShape('circle');
      },
    },
    {
      key: 'line-up',
      action: () => {
        SocketStore.setSelectedShape('line-up');
      },
    },
    {
      key: 'rotate-left',
      action: () => {
        SocketStore.setSelectedShape('rotate-left');
      },
    },
    {
      key: 'rotate-right',
      action: () => {
        SocketStore.setSelectedShape('rotate-right');
      },
    },
    {
      key: 'color',
      action: () => {
        SocketStore.setSelectedShape('color');
      },
    },
    {
      key: 'eraser',
      action: () => {
        SocketStore.setSelectedShape('eraser');
      },
    }
  ];


  const selectedShape = SocketStore.selectedShape;

  return (
    <div className="tech-call-left-side">

      <div className="tech-call-left-side-tool-list">
        {tools.map((tool, index) => <ShapeTool tool={tool} index={index} selected={selectedShape === tool.key} isColorPickerOpen={selectedShape === 'color'} />)}
      </div>

      <div className="tech-call-left-side-bottom">
        <Profile />
        <img src={selfixSmallLogoIcon} alt="selfix-small-logo" />
      </div>
    </div>
  );
};

export default observer(TechCallLeftSide);